import React, { Component, useEffect, useState } from "react";
import $ from "jquery";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sisMapActions from "store/modules/rds_sisMap";

import { ImMap, ImSearch } from "react-icons/im";
import { HiInformationCircle } from "react-icons/hi";
import { MdClose } from "react-icons/md";

import SisOverlay from "store/sis/SisOverlay";
import SisPagination from "store/sis/component/SisPagination";
import * as sisCom from "store/sis/SisCommon";
import SisInput from "store/sis/component/SisInputText";

//import MyMap from "./myMap/myMap";
import RealEstate from "./realEstate/realEstate";
import Transportation from "./transportation/transportation";
import Living from "./living/living";
import Welfare from "./welfare/welfare";
import Culture from "./culture/culture";
import Safety from "./safety/safety";
import Sanitary from "./sanitary/sanitary";
//import Weather from "./weather/weather";
//import Tour from "./tour/tour";
//import News from "./news/news";
import Population from "./population/population";
import Construction from "./construction/construction";

import "./left.scss";

class Left extends Component {
    state = {
        placeSearchResult: null,
        searchOverlay: null,
        menuCategory: '',
        activeMenu: '',
        constructionYN: null
    };

    // componentDidMount() {
    //     this.setState({
    //         activeMenu: this.props.aboutProps === undefined ? 'population' : this.props.aboutProps
    //     });
    //     this.callUserConfig();
    // }
    componentDidMount() {
        const activeMenu =
            this.props.aboutProps === undefined
                ? "population"
                : this.props.aboutProps;

        this.setState({
            activeMenu,
            menuCategory: activeMenu
        });

        this.callUserConfig();
    }

    callUserConfig = () => {
        fetch('/api/com/user/config')
            .then(response => response.json())
            .then(data => {
                //if (data.javaIp == "211.253.121.18" || data.javaIp == "211.253.121.34")
                if (data.javaIp === "211.253.121.18" || data.javaIp === "211.253.121.34" || data.javaIp === "127.0.0.1" || data.javaIp === "10.30.0.63") {
                    this.setState({
                        constructionYN: 'N'
                    });
                } else {
                    this.setState({
                        constructionYN: 'N'
                    });
                }
                //console.log("자바함수 : " + data.javaIp + " , 리퀘스트 : " + data.clientIp)
            })
    }

    menuClick = (evt) => {
        const id = evt.currentTarget.id;
        const prev = $(`.${this.props.className} .tab.active`);

        let category = "";

        if (id !== this.state.menuCategory) {
            if (id === "population") {
                category = "인구";
            } else if (id === "transportation") {
                category = "교통";
            } else if (id === "living") {
                category = "생활";
            } else if (id === "welfare") {
                category = "복지";
            } else if (id === "sanitary") {
                category = "보건";
            } else if (id === "culture") {
                category = "문화";
            } else if (id === "safety") {
                category = "안전";
            } else if (id === "realEstate") {
                category = "부동산";
            } else if (id === "construction") {
                category = "건설사업";
            }

            this._setVisitInfo(document.referrer, category);
        }

        $(".tabWrap .tab .searchWrap .listWrap").remove();
        $(".sisModalWrap").hide();
        $(prev).find(".close").click();

        if (id === "information") {
            $("#mapInformation").show();
            return;
        }

        this.setState({
            menuCategory: id,
            activeMenu: id
        });
    };

    _setVisitInfo = (ref, category) => {
        $.ajax({
            url: '/api/setVisit',
            data: {
                ref: ref,
                visitCategory: category
            },
            type: 'get',
            success: (res) => {

            },
            error: (err) => {
                console.error(err);
            }

        })
    }

    // 명칭검색 (카카오)
    searchName = (page = 1) => {
        var self = this;
        const size = 15;
        const query = `전남광주통합특별시 ${$("#keyword").val()}`;

        var data = {
            page,
            size,
            query,
            request: "search",
            format: "json",
            type: "place",
            crs: "EPSG:4326",
        };

        // AJAX 주소 검색 요청
        /*$.ajax({
            url: "/map/proxy/vSearch.do",
            type: "get",
            dataType: "json",
            data: data, // 요청 변수 설정
            success: function (res) {
                var res = res.response;

                if (res.record.total > 0) {
                    const items = res.result.items || [];

                    var ele = (
                        <>
                            <div className="countWrap">
                                <span>검색결과 </span>
                                <span className="count">{res.record.total}</span>
                                <span>건</span>
                            </div>

                            <div className="itemsWrap">{self.createTable(items, res.record.total)}</div>

                            <div className="paginationWrap">
                                <SisPagination totalCount={res.record.total} viewCount={size}
                                               onClick={self.searchName}/>
                            </div>
                        </>
                    );

                    self.setState({
                        placeSearchResult: ele,
                    });
                } else {
                    data.type = "address";
                    data.category = "road";

                    // 도로명주소 찾기
                    $.ajax({
                        url: "/map/proxy/vSearch.do",
                        type: "get",
                        dataType: "json",
                        data,
                        success: function (res) {
                            res = res.response;

                            if (res.record.total > 0) {
                                const items = res.result.items || [];

                                var ele = (
                                    <>
                                        <div className="countWrap">
                                            <span>검색결과 </span>
                                            <span className="count">{res.record.total}</span>
                                            <span>건</span>
                                        </div>

                                        <div className="itemsWrap">{self.createTable(items, res.record.total)}</div>

                                        <div className="paginationWrap">
                                            <SisPagination totalCount={res.record.total} viewCount={size}
                                                           onClick={self.searchName}/>
                                        </div>
                                    </>
                                );

                                self.setState({
                                    placeSearchResult: ele,
                                });
                            } else {
                                data.type = "address";
                                data.category = "PARCEL";

                                // 도로명주소 찾기
                                $.ajax({
                                    url: "/map/proxy/vSearch.do",
                                    type: "post",
                                    contentType: "application/json",
                                    dataType: "json",
                                    data: JSON.stringify(data),
                                    success: function (res) {
                                        res = res.response;

                                        if (res.record.total > 0) {
                                            const items = res.result.items || [];

                                            var ele = (
                                                <>
                                                    <div className="countWrap">
                                                        <span>검색결과 </span>
                                                        <span className="count">{res.record.total}</span>
                                                        <span>건</span>
                                                    </div>

                                                    <div
                                                        className="itemsWrap">{self.createTable(items, res.record.total)}</div>

                                                    <div className="paginationWrap">
                                                        <SisPagination totalCount={res.record.total} viewCount={size}
                                                                       onClick={self.searchName}/>
                                                    </div>
                                                </>
                                            );

                                            self.setState({
                                                placeSearchResult: ele,
                                            });
                                        } else {
                                            var ele = (
                                                <>
                                                    <div className="countWrap">
                                                        <span>검색결과 </span>
                                                        <span className="count">0</span>
                                                        <span>건</span>
                                                    </div>
                                                </>
                                            );

                                            self.setState({
                                                placeSearchResult: ele,
                                            });
                                        }
                                    },
                                });
                            }
                        },
                    });
                }
            },
            error: function (xhr, status, error) {
                alert("에러발생"); // AJAX 호출 에러
            },
        });*/

        // AJAX 주소 검색 요청 (POST 방식으로 전환)
        $.ajax({
            url: "/map/proxy/vSearch.do",
            type: "post",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify(data), // JSON 문자열로 변환
            success: function (res) {
                res = res.response;

                if (res.record.total > 0) {
                    const items = res.result.items || [];

                    var ele = (
                        <>
                            <div className="countWrap">
                                <span>검색결과 </span>
                                <span className="count">{res.record.total}</span>
                                <span>건</span>
                            </div>

                            <div className="itemsWrap">{self.createTable(items, res.record.total)}</div>

                            <div className="paginationWrap">
                                <SisPagination totalCount={res.record.total} viewCount={size}
                                    onClick={self.searchName} />
                            </div>
                        </>
                    );

                    self.setState({
                        placeSearchResult: ele,
                    });
                } else {
                    data.type = "address";
                    data.category = "road";

                    // 도로명주소 찾기
                    $.ajax({
                        url: "/map/proxy/vSearch.do",
                        type: "post",
                        contentType: "application/json",
                        dataType: "json",
                        data: JSON.stringify(data),
                        success: function (res) {
                            res = res.response;

                            if (res.record.total > 0) {
                                const items = res.result.items || [];

                                var ele = (
                                    <>
                                        <div className="countWrap">
                                            <span>검색결과 </span>
                                            <span className="count">{res.record.total}</span>
                                            <span>건</span>
                                        </div>

                                        <div className="itemsWrap">{self.createTable(items, res.record.total)}</div>

                                        <div className="paginationWrap">
                                            <SisPagination totalCount={res.record.total} viewCount={size}
                                                onClick={self.searchName} />
                                        </div>
                                    </>
                                );

                                self.setState({
                                    placeSearchResult: ele,
                                });
                            } else {
                                data.type = "address";
                                data.category = "PARCEL";

                                // 지번주소 찾기
                                $.ajax({
                                    url: "/map/proxy/vSearch.do",
                                    type: "post",
                                    contentType: "application/json",
                                    dataType: "json",
                                    data: JSON.stringify(data),
                                    success: function (res) {
                                        res = res.response;

                                        if (res.record.total > 0) {
                                            const items = res.result.items || [];

                                            var ele = (
                                                <>
                                                    <div className="countWrap">
                                                        <span>검색결과 </span>
                                                        <span className="count">{res.record.total}</span>
                                                        <span>건</span>
                                                    </div>

                                                    <div className="itemsWrap">{self.createTable(items, res.record.total)}</div>

                                                    <div className="paginationWrap">
                                                        <SisPagination totalCount={res.record.total} viewCount={size}
                                                            onClick={self.searchName} />
                                                    </div>
                                                </>
                                            );

                                            self.setState({
                                                placeSearchResult: ele,
                                            });
                                        } else {
                                            var ele = (
                                                <>
                                                    <div className="countWrap">
                                                        <span>검색결과 </span>
                                                        <span className="count">0</span>
                                                        <span>건</span>
                                                    </div>
                                                </>
                                            );

                                            self.setState({
                                                placeSearchResult: ele,
                                            });
                                        }
                                    },
                                });
                            }
                        },
                    });
                }
            },
            error: function (xhr, status, error) {
                alert("에러발생"); // AJAX 호출 에러
            },
        });
    };

    // 명칭검색 테이블 생성
    createTable = (items, totalCount, isRoadAddr) => {
        return (
            <>
                {items.map((row, idx) => {
                    if (!isRoadAddr) {
                        var title = row.title || "-";
                        row.address.bldnm = row.address.bldnm || "";
                        row.address.bldnmdc = row.address.bldnmdc || "";

                        var addr = row.address.parcel || "-";
                        var road = row.address.road || "-";

                        if (title == "-") title = (row.address.bldnm + " " + row.address.bldnmdc) != " " ? row.address.bldnm + " " + row.address.bldnmdc : "-";
                        if (title == "-") title = addr || "-";
                        if (title == "-") title = road || "-";

                        return (
                            <div
                                key={idx}
                                className="item"
                                onClick={() => {
                                    $("#searchOverlayTitle").text(title);
                                    this.movePoint(row);
                                }}
                            >
                                <span className="itemTitle">{title}</span>
                                <span className="itemRoadAddr">{addr}</span>
                                <span className="itemAddr">{road}</span>
                            </div>
                        );
                    } else {
                        var roadAddr = row.roadAddrPart1;
                        var bdNm = row.bdNm;
                        var jibunAddr = row.jibunAddr.replace(bdNm, "");
                        // var pnu = row.admCd + (row.mtYn == 0 ? "1" : "2") + self.lpad(row.lnbrMnnm, 4, "0") + self.lpad(row.lnbrSlno, 4, "0");

                        return (
                            <div
                                key={idx}
                                className="item"
                                onClick={() => {
                                    $("#searchOverlayTitle").text(title);
                                    this.movePoint(row);
                                }}
                            >
                                <span className="itemTitle">{(bdNm ? bdNm : "-")}</span>
                                <span className="itemRoadAddr">{jibunAddr}</span>
                                <span className="itemAddr">{roadAddr}</span>
                            </div>
                        );
                    }
                })}
            </>
        );
    };

    // 명칭검색 위치이동
    movePoint = (data) => {
        const { sisMap } = this.props.sis;
        const { css } = this.props;

        const x = parseFloat(data.x || data.point.x);
        const y = parseFloat(data.y || data.point.y);
        const coordinate = [x, y];

        const wrap = document.createElement("div");
        wrap.id = "searchOverlayWrap";
        document.body.appendChild(wrap);

        const overlay = new SisOverlay(`#searchOverlayWrap`, sisMap.map, "bottom-center");

        this.setState({
            searchOverlay: overlay,
        });

        sisMap.setCenter(coordinate, "EPSG:4326");
        overlay.setPosition(sisMap.view.getCenter());
        $("#searchOverlayWrap").show();

        const coord = sisMap.view.getCenter();
        this.getJijukByCoord(coord);

        sisMap.view.setZoom(sisMap.view.getZoom() - 2);
    };

    // 좌표로 지적도 찾기
    getJijukByCoord = (coord) => {
        const { sisLayer, sisMap } = this.props.sis;

        const feature = sisLayer.getPropByCoordinate(coord, "LYR0019");
        // console.log(feature);

        if (feature) {
            sisLayer.wfs.selectLayer.getSource().clear();
            sisLayer.wfs.selectLayer.getSource().addFeature(feature);
        }
    };

    render() {
        return (
            <div className={this.props.className}>
                <div className="placeSearchWrap">
                    <div
                        className="expandWrap"
                        onClick={() => {
                            $(".placeSearchWrap .searchWrap").toggle();
                        }}
                    >
                        <div>통합검색</div>
                        <ImSearch />
                    </div>

                    <div className="searchWrap">
                        <div className="searchTitleWrap">
                            <span>부동산 통합검색</span>
                            <MdClose onClick={() => $(".placeSearchWrap .searchWrap").toggle()} />
                        </div>

                        <div className="inputWrap">
                            {/* <span className="inputTitle">명칭</span> */}
                            <SisInput
                                id="keyword"
                                style={{
                                    width: "100%",
                                }}
                                ref={(ref) => (this.keyword = ref)}
                                placeholder="주소, 명칭을 입력하세요."
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        this.searchName(1);
                                    }
                                }}
                            />
                        </div>

                        <div className="btnWrap">
                            <button
                                id="btnRefresh"
                                onClick={() => {
                                    $("#searchOverlayWrap").hide();
                                    $("#searchOverlayTitle").text("");
                                    this.props.sis.sisLayer.wfs.selectLayer.getSource().clear();
                                    this.keyword.clear();
                                    this.setState({
                                        placeSearchResult: null,
                                    });
                                }}
                            >
                                초기화
                            </button>
                            <button id="btnSearch" onClick={() => this.searchName(1)}>
                                검색
                            </button>
                        </div>

                        <div className="searchResultWrap">{this.state.placeSearchResult}</div>
                    </div>
                </div>

                <div
                    className="toggle"
                    onClick={() => {
                        $(".leftWrap").toggleClass("close");
                        $(".sisMapWrap").toggleClass("expand");
                        $(".leftWrap > .toggle").toggleClass("close");

                        const left = $("#mapScaleWrap").css("left");

                        if (left === "394px") {
                            $(".mapScaleWrap").css("left", "10px");
                            // $(".myPosCopy").css("left", "55px");
                        } else {
                            $(".mapScaleWrap").css("left", "394px");
                            // $(".myPosCopy").css("left", "439px");
                        }

                        this.props.SisMapActions.updateSize(200);
                    }}
                ></div>
                <div className="menuWrap">
                    
                    <div id="population" className={`menu ${this.state.activeMenu === 'population' ? 'active' : null}`} onClick={this.menuClick}>
                        인구
                    </div>
                    <div id="transportation" className={`menu ${this.state.activeMenu === 'transportation' ? 'active' : null}`} onClick={this.menuClick}>
                        교통
                    </div>
                    <div id="living" className={`menu ${this.state.activeMenu === 'living' ? 'active' : null}`} onClick={this.menuClick}>
                        생활
                    </div>
                    <div id="welfare" className={`menu ${this.state.activeMenu === 'welfare' ? 'active' : null}`} onClick={this.menuClick}>
                        복지
                    </div>
                    <div id="sanitary" className={`menu ${this.state.activeMenu === 'sanitary' ? 'active' : null}`} onClick={this.menuClick}>
                        보건
                    </div>
                    <div id="culture" className={`menu ${this.state.activeMenu === 'culture' ? 'active' : null}`} onClick={this.menuClick}>
                        문화
                    </div>
                    <div id="safety" className={`menu ${this.state.activeMenu === 'safety' ? 'active' : null}`} onClick={this.menuClick}>
                        안전
                    </div>
                    <div id="realEstate" className={`menu ${this.state.activeMenu === 'realEstate' ? 'active' : null}`} onClick={this.menuClick}>
                        부동산
                    </div>
                    {this.state.constructionYN === 'Y' && (
                        <div id="construction" className={`menu ${this.state.activeMenu === 'construction' ? 'active' : null}`} onClick={this.menuClick}>
                            건설사업
                        </div>
                    )}
                   {/* <div id="tour" className="menu" onClick={this.menuClick}>
                        관광
                    </div>*/}
                    {/*<div id="news" className="menu" onClick={this.menuClick}>
                        전남소식
                    </div>*/}

                    {/*  <div id="myMap" className="menu" onClick={this.menuClick}>
                        <ImMap size="30px"/>
                        내주제도
                    </div>*/}
                    {/* <div id="information" className="menu" onClick={this.menuClick}>
                        <HiInformationCircle size="30px"/>
                        정보보기
                    </div>*/}
                </div>

                <div className="tabWrap">
                
                    <div id="population_tab" className={`tab ${this.state.activeMenu === 'population' ? 'active' : null}`}>
                        <Population />
                    </div>
                    <div id="transportation_tab" className={`tab ${this.state.activeMenu === 'transportation' ? 'active' : null}`}>
                        <Transportation />
                    </div>
                    <div id="living_tab" className={`tab ${this.state.activeMenu === 'living' ? 'active' : null}`}>
                        <Living />
                    </div>
                    <div id="welfare_tab" className={`tab ${this.state.activeMenu === 'welfare' ? 'active' : null}`}>
                        <Welfare />
                    </div>
                    <div id="sanitary_tab" className={`tab ${this.state.activeMenu === 'sanitary' ? 'active' : null}`}>
                        <Sanitary />
                    </div>
                    <div id="culture_tab" className={`tab ${this.state.activeMenu === 'culture' ? 'active' : null}`}>
                        <Culture />
                    </div>
                    <div id="safety_tab" className={`tab ${this.state.activeMenu === 'safety' ? 'active' : null}`}>
                        <Safety />
                    </div>
                    <div id="realEstate_tab" className={`tab ${this.state.activeMenu === 'realEstate' ? 'active' : null}`}>
                        <RealEstate />
                    </div>
                    <div id="construction_tab" className={`tab ${this.state.activeMenu === 'construction' ? 'active' : null}`}>
                        <Construction />
                    </div>
                  {/* <div id="weather_tab" className="tab">
                        <Weather/>
                    </div>
                    <div id="tour_tab" className="tab">
                        <Tour/>
                    </div>
                    <div id="news_tab" className="tab">
                        <News/>
                    </div>

                    <div id="myMap_tab" className="tab">
                        <MyMap/>
                    </div>*/}
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => ({
        sis: state.sisMap,
    }),
    (dispatch) => ({
        SisMapActions: bindActionCreators(sisMapActions, dispatch),
    })
)(Left);
